<template>
  <div>
    <router-view :key="moduleKey" v-if="moduleIsReady"/>
    <div v-else>Loading Reports Data...</div>
  </div>
</template>

<script>
export default {
  name: 'ReportsModule',

  created() {
    // console.log('Inside Index.vue Created');
    this.bootstrap();
  },

  computed: {
    loggedUserId() {
      return this.$store.getters.loggedUser ? this.$store.getters.loggedUser.id : '';
    },

    moduleIsReady() {
      return true;
    },

    moduleKey() {
      return 'Reports';
    },
  },

  methods: {
    async bootstrap() {
      const userId = this.loggedUserId;
      // console.log(userId);
    },
    userId() {
      return this.$store.getters.loggedUser ? this.$store.getters.loggedUser.id : null;
    },
  },
};
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
